import { useConfig } from '@/contexts/ConfigContext';
import { initAvoParams } from '@/utils/avoGtm.utils';
import _isBoolean from 'lodash/isBoolean';
import _includes from 'lodash/includes';
import { useEffect } from 'react';
import { useStore } from '@/contexts/StoreContext';
import useStateOfUserStatus from '@/hooks/useStateOfUser';
import useStateOfAuth from '@/hooks/useStateOfAuth';
import useStateOfEssentials from '@/hooks/useStateOfEssentials';
import { useRouter } from 'next/router';

function Essentials({ splitKey }: { splitKey: string }): JSX.Element {
  const { countryCode, language, isMobile: isMobileConfig } = useConfig();
  const store = useStore();

  const { isAuthInitialized } = useStateOfUserStatus(store);
  const { userId, isLoggedIn, hasVerifiedPhone, hasVerifiedEmail } = useStateOfAuth(store);
  const { currency } = useStateOfEssentials(store);

  const { pathname } = useRouter();
  const isMobile = _isBoolean(isMobileConfig) ? isMobileConfig : _includes(pathname, 'mweb');

  useEffect(() => {
    if (countryCode && _isBoolean(isMobile) && isAuthInitialized && splitKey) {
      initAvoParams(
        {
          countryCode,
          isMobile,
          hasVerifiedPhone,
          hasVerifiedEmail,
          isLoggedIn,
          userId,
          language,
          currency,
          splitKey,
        },
        true
      );
    }
  }, [countryCode, isMobile, isAuthInitialized, userId, splitKey]);

  return null;
}

export default Essentials;
